export default __webpack_public_path__ + "static/media/polygonForward.8482de98.svg";